<template>
    <div class="common-filter" :style="showMore || !showMoreStatus ? '' : 'height: 42px; overflow: hidden'">
        <el-form
            class="common-filter-container"
            label-width="82px">
            <el-form-item
                v-if="showFilter.indexOf('classTime') > -1"
                :style="fullWidth > minWidth ? 'width: 25%' : 'width: 33.33%'" label="上课时间">
                <el-date-picker
                    v-model="classTime"
                    type="daterange"
                    range-separator="至"
                    clearable
                    value-format="timestamp"
                    start-placeholder="开始日期"
                    @change="classTimeSubmit"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item
                v-if="showFilter.indexOf('class') > -1"
                :style="fullWidth > minWidth ? 'width: 25%' : 'width: 33.33%'" label="班 级">
                <el-input
                    v-model.trim="filter.classQuery"
                    :maxlength="50"
                    placeholder="班级名称/编号"
                    @keyup.enter.native="submit"
                    >
                    <i slot="suffix"
                        @click="submit"
                        class="el-input__icon el-icon-search pointer">
                    </i>
                </el-input>
            </el-form-item>
            <el-form-item
                v-if="showFilter.indexOf('good') > -1"
                :style="fullWidth > minWidth ? 'width: 25%' : 'width: 33.33%'" label="商 品">
                <el-input
                    v-model.trim="filter.goodsQuery"
                    :maxlength="50"
                    placeholder="商品名称/编号"
                    @keyup.enter.native="submit"
                    >
                    <i slot="suffix"
                        @click="submit"
                        class="el-input__icon el-icon-search pointer">
                    </i>
                </el-input>
            </el-form-item>
            <el-form-item
                v-if="showFilter.indexOf('teacher') > -1"
                :style="fullWidth > minWidth ? 'width: 25%' : 'width: 33.33%'" label="老 师">
                <el-input
                    v-model.trim="filter.teacherQuery"
                    :maxlength="20"
                    placeholder="老师姓名/化名/工号"
                    @keyup.enter.native="submit"
                    >
                    <i slot="suffix"
                        @click="submit"
                        class="el-input__icon el-icon-search pointer">
                    </i>
                </el-input>
            </el-form-item>
            <el-form-item
                v-if="showFilter.indexOf('businessUnit') > -1"
                :style="fullWidth > minWidth ? 'width: 25%' : 'width: 33.33%'" label="事业部">
                <el-select
                    placeholder="请选择事业部"
                    @change="submit"
                    clearable
                    v-model="filter.businessUnitId">
                    <el-option
                        v-for="item in config.businessUnit"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item
                v-if="showFilter.indexOf('masterTeacher') > -1"
                :style="fullWidth > minWidth ? 'width: 25%' : 'width: 33.33%'" label="班主任">
                <user-filter
                    v-model="filter.masterTeacherID"
                    @change="submit" />
            </el-form-item>
            <!-- <el-form-item
                v-if="showFilter.indexOf('classNo') > -1"
                :style="fullWidth > 1440 ? 'width: 25%' : 'width: 33.33%'" label="班级编码">
                <el-input
                    v-model.trim="filter.classNo"
                    :maxlength="20"
                    placeholder="请输入班级编码"
                    @keyup.enter.native="submit"
                    >
                    <i slot="suffix"
                        @click="submit"
                        class="el-input__icon el-icon-search pointer">
                    </i>
                </el-input>
            </el-form-item> -->
            <el-form-item
                v-if="showFilter.indexOf('productName') > -1"
                :style="fullWidth > minWidth ? 'width: 25%' : 'width: 33.33%'" label="产 品">
                <el-input
                    v-model.trim="filter.productName"
                    :maxlength="50"
                    placeholder="请输入产品名称"
                    @keyup.enter.native="submit">
                    <i slot="suffix"
                        @click="submit"
                        class="el-input__icon el-icon-search pointer">
                    </i>
                </el-input>
            </el-form-item>
            <!-- <el-form-item
                v-if="showFilter.indexOf('productName') > -1"
                :style="fullWidth > 1440 ? 'width: 25%' : 'width: 33.33%'" label="课 程">
                <el-input
                    v-model="filter.className"
                    :maxlength="20"
                    placeholder="请输入课程"
                    @keyup.enter.native="submit"
                    >
                    <i slot="suffix"
                        @click="submit"
                        class="el-input__icon el-icon-search pointer">
                    </i>
                </el-input>
            </el-form-item> -->
            <el-form-item
                v-if="showFilter.indexOf('classStatus') > -1"
                :style="fullWidth > minWidth ? 'width: 25%' : 'width: 33.33%'" label="班级状态">
                <el-select
                    placeholder="请选择班级状态"
                    @change="submit"
                    clearable
                    v-model="filter.classStatus">
                    <el-option
                        v-for="item in classStatusOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item
                v-if="showFilter.indexOf('teacherType') > -1"
                :style="fullWidth > minWidth ? 'width: 25%' : 'width: 33.33%'" label="老师类型">
                <el-select
                    placeholder="请选择老师类型"
                    @change="submit"
                    clearable
                    v-model="filter.teacherType">
                    <el-option
                        v-for="item in config.teacherType"
                         :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item
                v-if="showFilter.indexOf('examWay') > -1"
                :style="fullWidth > minWidth ? 'width: 25%' : 'width: 33.33%'" label="笔面试">
                <el-select
                    placeholder="请选择笔面试"
                    @change="submit"
                    clearable
                    v-model="filter.examWayCode">
                    <el-option
                        v-for="item in config.examWay"
                         :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item
                v-if="showFilter.indexOf('examType') > -1"
                :style="fullWidth > minWidth ? 'width: 25%' : 'width: 33.33%'" label="考试类型">
                <!-- <el-select
                    placeholder="请选择考试类型"
                    @change="submit"
                    clearable
                    v-model="filter.examTypeCode">
                    <el-option
                        v-for="item in config.examType"
                         :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select> -->
                <el-cascader
                    expand-trigger="hover"
                    style="width: 100%"
                    clearable
                    :options="setExamTypeOptions()"
                    @change="submit"
                    v-model="filter.examTypeCodeTree">
                </el-cascader>
            </el-form-item>
            <el-form-item
                v-if="showFilter.indexOf('productType') > -1"
                :style="fullWidth > minWidth ? 'width: 25%' : 'width: 33.33%'" label="产品类型">
                <!-- <el-select
                    placeholder="请选择产品类型"
                    @change="submit"
                    clearable
                    v-model="filter.productTypeId">
                    <el-option
                        v-for="item in config.productType"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select> -->
                <el-cascader
                    expand-trigger="hover"
                    style="width: 100%"
                    clearable
                    :options="setProductTypeOptions()"
                    @change="submit"
                    v-model="filter.productTypeTree">
                </el-cascader>
            </el-form-item>
            <el-form-item
                v-if="showFilter.indexOf('isDel') > -1"
                :style="fullWidth > minWidth ? 'width: 25%' : 'width: 33.33%'" label="是否有效">
                <el-select
                    placeholder="请选择商品有效性"
                    @change="submit"
                    clearable
                    v-model="filter.isDel">
                    <el-option
                        v-for="item in config.isDel"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>

            <!--  -->
            <!-- 第一列 -->
           <el-row style="width:30%;margin-right:30px">
                 <el-col>
                    <el-form-item
                    v-if="showFilter.indexOf('projectChName') > -1"
                    style="width: 100%" label="项目名称(中文)" label-width="110px">
                        <el-input
                            placeholder="请输入项目的中文名称"
                            @change="submit"
                            clearable
                            v-model="filter.projectChName"
                            ref="projectChName">
                            
                        </el-input>
                    </el-form-item> 
                </el-col>
                <el-col>
                    <el-form-item
                    v-if="showFilter.indexOf('isGeneratingCode') > -1"
                    style="width: 100%" label="是否已生成代码" label-width="110px">
                    <el-select
                        placeholder="请选择"
                        @change="submit"
                        ref="isGeneratingCode"
                        v-model="filter.isGeneratingCode">
                        <!-- ref="isGeneratingCode" -->
                        <el-option
                            v-for="item in isGeneratingCode"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                            >
                        </el-option>
                    </el-select>
                    </el-form-item>
                </el-col>
           </el-row>
           <!-- 第二列 -->
           <el-row style="width:30%;margin-right:30px">
                <el-col>
                    <el-form-item
                    v-if="showFilter.indexOf('projectName') > -1"
                    style="width: 100%" label="项目名称(英文)" label-width="110px">
                        <el-input
                            placeholder="请输入项目的英文名称"
                            clearable
                            v-model="filter.projectName"
                            ref="projectName">
                        </el-input>
                    </el-form-item>
                </el-col>
            
            </el-row>
            <!-- 第三列 -->
            <el-row style="width:30%;">
                <el-col>
                    <el-form-item
                    v-if="showFilter.indexOf('createName') > -1"
                    style="width: 100%" label="创 建 人"  label-width="70px">
                    <el-input
                            placeholder="请输入创建人姓名" 
                            clearable
                            v-model="filter.createName"
                            ref="createName">
                        </el-input>
                    </el-form-item>
                </el-col>
                
            </el-row>
            <!--  -->

            <el-form-item
                v-if="showFilter.indexOf('subDepartment') > -1"
                :style="fullWidth > minWidth ? 'width: 25%' : 'width: 33.33%'" label="分校分部">
                <organization-filter
                    placeholder="请选择分校分部"
                    v-model="filter.node"
                    @change="submit"/>
            </el-form-item>
        </el-form>
     <div v-if="showMoreStatus" class="common-filter-show-more-container">
            <span
                class="common-filter-show-more pointer"
                style="margin-right:15px"
                @click="changeShow" >
                {{ showMore ? '收起' : '展开' }}
                <i :class="elIconStaffListMore"></i>
            </span>
            <button class="el-button el-button--primary el-button--small" v-on:click="search">查询</button>
        </div>
       
        <div v-else style="width: 16px"></div> 
        
    </div>
</template>

<script>
import OrganizationFilter from "library/components/OrganizationFilter";
import UserFilter from "library/components/UserFilter";

export default {
  components: {
    OrganizationFilter,
    UserFilter
  },
  props: {
    // 根据传递的showFilter来显示筛选项
    showFilter: {
      default: []
    },
    // 是否需要收起功能
    showMoreStatus: {
      default: false
    },
    minWidth: {
      default: 1440
    }
  },
  data() {
    return {
      fullWidth: document.documentElement.clientWidth,
      showMore: false,
      elIconStaffListMore: "el-icon-caret-bottom",
      filter: {},
      classTime: [],
      classStatusOptions: [],
      config: {
        businessUnit: [], // 事业部
        examWay: [], // 笔面试类型
        examType: [], // 考试类型
        productType: [], // 产品类型
        stage: [], // 阶段
        subject: [], // 科目
        studentGender: [], // 学员性别
        education: [], // 学员学历
        identities: [], // 履历
        protocolType: [], // 是否是协议商品
        teacherType: [], // 教师类型
        paikeTeacherType: [], // 主讲助教类型
        classStatus: [], // 班级状态
        lessonStatus: [], // 课节状态
        orderStatus: [], // 订单状态
        orderOperateType: [], // 学员订单出入班状态
        placeType: [], // 场地类型
        effectiveStatus: [], // 场地是否有效
        hotelRoomType: [], // 酒店房间类型
        isDel: [], // 商品是否有效
        examTypeTree: [], // 考试类型级联数据
        productTypeTree: [] // 产品类型级联数据
      },
      isGeneratingCode: [
        { id: "", name: "请选择" },
        { id: "1", name: "已生成代码" },
        { id: "0", name: "未生成代码" }
      ],
      projectChName: [] //中文项目名
    };
  },
  // watch: {
  //     '$store.state.enumList': function(newVal, oldVal) {
  //         if (newVal !== oldVal) {
  //             this.config = newVal
  //             let classStatusOptions = [...this.config.classStatus]
  //             classStatusOptions.pop()
  //             // classStatusOptions.splice()
  //             this.classStatusOptions = classStatusOptions
  //         }
  //     }
  // },
  mounted() {
    this.config = this.$store.state.enumList;
    let classStatusOptions = [...this.config.classStatus];
    classStatusOptions.pop();
    classStatusOptions.splice(5, 1);
    this.classStatusOptions = classStatusOptions;

    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.fullWidth = document.documentElement.clientWidth;
    },
    changeShow() {
      this.showMore = !this.showMore;
      this.elIconStaffListMore = this.showMore
        ? "el-icon-caret-top"
        : "el-icon-caret-bottom";
      this.$emit("changeShow", this.showMore);
    },
    submit() {
      if (this.filter.node) {
        if (
          Object.prototype.toString.call(this.filter.node) === "[object Array]"
        ) {
          this.filter.nodeId = this.filter.node[this.filter.node.length - 1];
        } else {
          this.filter.nodeId = this.filter.node;
        }
      }
      if (this.filter.examTypeCodeTree) {
        this.filter.examTypeCode = this.filter.examTypeCodeTree.length
          ? this.filter.examTypeCodeTree[
              this.filter.examTypeCodeTree.length - 1
            ]
          : "";
      }
      if (this.filter.productTypeTree) {
        this.filter.productTypeId = this.filter.productTypeTree.length
          ? this.filter.productTypeTree[this.filter.productTypeTree.length - 1]
          : null;
      }
      this.$emit("change", this.filter);
    },
    classTimeSubmit(val) {
      if (val && val[0]) {
        this.filter.startTime = val[0];
        this.filter.endTime = val[1];
      } else {
        this.filter.startTime = null;
        this.filter.endTime = null;
      }
      this.submit();
    },
    setExamTypeOptions() {
      let options = [];
      this.config.examTypeTree.forEach(
        (businessUnitItem, businessUnitIndex) => {
          let value = businessUnitItem.businessUnitId;
          let label = businessUnitItem.businessUnitName;
          let children = [];
          businessUnitItem.examTypeDtoList.forEach((item, index) => {
            children.push({
              value: item.code,
              label: item.name
            });
          });
          options.push({
            value,
            label,
            children
          });
        }
      );
      return options;
    },
    setProductTypeOptions() {
      let options = [];
      this.config.productTypeTree.forEach(
        (businessUnitItem, businessUnitIndex) => {
          let businessUnitValue = businessUnitItem.businessUnitId;
          let businessUnitLabel = businessUnitItem.businessUnitName;
          let businessUnitChildren = [];
          businessUnitItem.examWayRespDtoList.forEach(
            (examWayItem, examWayIndex) => {
              let examWayValue = examWayItem.examWayCode;
              let examWayLabel = examWayItem.examWayName;
              let examWayChildren = [];
              examWayItem.productTypeDtoList.forEach((item, index) => {
                examWayChildren.push({
                  value: item.id,
                  label: item.name
                });
              });
              businessUnitChildren.push({
                value: examWayValue,
                label: examWayLabel,
                children: examWayChildren
              });
            }
          );
          options.push({
            value: businessUnitValue,
            label: businessUnitLabel,
            children: businessUnitChildren
          });
        }
      );
      return options;
    },
    search() {
      this.$emit(
        "search",
        this.$refs.projectChName.value,
        this.$refs.projectName.value,
        this.$refs.createName.value,
        this.$refs.isGeneratingCode.value
      );
    }
  }
};
</script>

